import FloatingToolbox from "components/FloatingToolbox";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import WorkplaceCollection from "./WorkplaceCollection";

interface WorkplaceCollectionModalProps {
  postIdParent: string;
  selImageId: string;
  onToggle(): void;
}
const WorkplaceCollectionModal = ({ postIdParent, selImageId, onToggle }: WorkplaceCollectionModalProps) => {

  return (
    <WorkplaceCollection postIdParent={postIdParent} selImageId={selImageId} onToggle={onToggle}></WorkplaceCollection>
  )
}

export default WorkplaceCollectionModal;